const REPORT_TYPE_OPTIONS = ['Summary reports', 'Notification reports'];

export { REPORT_TYPE_OPTIONS };
